import {MenuItem} from '_metronic/layout/components/header/header-menus/MenuItem'
import {Modal} from 'app/custom/modal/Modal'
import {useCallback, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import MyCard from './profile/MyCard'

const StdMenu = () => {
  const {t} = useTranslation()
  const location = useLocation()

  const [isShown, setIsShown] = useState(false)
  const [showMore, setShowMore] = useState(false)

  const toggle = useCallback(() => setIsShown((prev) => !prev), [])

  const menus = [
    {
      title: t('LABEL.MY_PROFILE'),
      to: '/student/my-profile',
      icon: 'fas fa-user-astronaut',
      color: '#8b5cf6',
    },
    {
      title: t('LABEL.MY_COURSES'),
      to: '/student/my-courses',
      icon: 'fas fa-graduation-cap',
      color: '#0d6efd',
    },
    {
      title: t('LABEL.MY_TRANSCRIPT'),
      to: '/student/my-transcript',
      icon: 'fas fa-medal',
      color: '#f59e0b',
    },
    {
      title: t('LABEL.MY_INVOICES'),
      to: '/student/my-invoices',
      icon: 'fas fa-file-invoice-dollar',
      color: '#f43f5e',
    },
    {
      title: t('MEETING.MEETINGS'),
      to: '/student/meetings',
      icon: 'fas fa-video',
      color: '#0ea5e9',
    },
    {
      title: t('LABEL.MY_LETTERS'),
      to: '/student/my-letters',
      icon: 'fas fa-envelope',
      color: '#8b5cf6',
    },
    {
      title: t('LABEL.MY_RESOURCE'),
      to: '/student/my-resource',
      icon: 'fas fa-cloud-download-alt',
      color: '#64748b',
    },
    {
      title: t('LABEL.MY_FEEDBACK'),
      to: '/student/my-feedback',
      icon: 'fas fa-star',
      color: '#22c55e',
    },
    {
      title: t('LABEL.CHAT'),
      to: '/student/chat-room',
      icon: 'fas fa-comment-dots',
      color: '#0d6efd',
    },
  ]

  const moreMenus = [
    {
      title: t('LABEL.MY_CARD'),
      icon: 'fas fa-id-card',
      color: '#ef4444',
      bgColor: '#fef2f2',
      borderColor: '#ef4444',
      action: toggle,
    },
    {
      title: t('LABEL.MY_DOCUMENTS'),
      to: '/student/my-documents',
      icon: 'fas fa-folder-open',
      color: '#0ea5e9',
      bgColor: '#f0f9ff',
      borderColor: '#0ea5e9',
    },
    {
      title: t('LABEL.MY_NOTES'),
      to: '/student/my-notes',
      icon: 'fas fa-pen-fancy',
      color: '#84cc16',
      bgColor: '#f7fee7',
      borderColor: '#84cc16',
    },
    {
      title: t('LABEL.MY_UMEF'),
      to: '/student/my-umef',
      icon: 'fas fa-landmark',
      color: '#8b5cf6',
      bgColor: '#f5f3ff',
      borderColor: '#8b5cf6',
    },
    {
      title: t('PARENT.PARENT_ACCOUNT'),
      to: '/student/parent',
      icon: 'fas fa-heart',
      color: '#2563eb',
      bgColor: '#eff6ff',
      borderColor: '#2563eb',
    },
  ]

  const isMenuActive = (to?: string) => {
    if (!to) return false
    return location.pathname === to || location.pathname.startsWith(`${to}/`)
  }

  const renderMenu = (menu: any) => {
    const active = isMenuActive(menu.to)

    return (
      <div
        className={`compact-menu-item px-3 ${active ? 'active-menu-item' : ''}`}
        style={
          active
            ? {
                backgroundColor: '#f1f7ff',
                borderColor: '#d6e6ff',
              }
            : {
                backgroundColor: '#ffffff',
                borderColor: '#e5e7eb',
              }
        }
      >
        <div className='compact-icon'>
          <i className={`${menu.icon}`} style={{color: active ? '#0d6efd' : menu.color}}></i>
        </div>

        <div className='menu-text'>
          <span className='menu-title' style={{color: active ? '#0d6efd' : '#334155'}}>
            {menu.title}
          </span>
        </div>

        <div className='menu-shine'></div>
      </div>
    )
  }

  const renderDropdownCard = (menu: any) => {
    const active = isMenuActive(menu.to)

    return (
      <div
        className={`dropdown-card ${active ? 'active-dropdown-card' : ''}`}
        style={
          active
            ? {
                backgroundColor: '#f1f7ff',
                borderColor: '#0d6efd',
              }
            : {
                backgroundColor: menu.bgColor,
                borderColor: menu.borderColor,
              }
        }
      >
        <div className='dropdown-icon-wrapper'>
          <i className={`${menu.icon}`} style={{color: active ? '#0d6efd' : menu.color}}></i>
        </div>

        <div className='dropdown-info'>
          <span className='dropdown-title' style={{color: active ? '#0d6efd' : menu.color}}>
            {menu.title}
          </span>
        </div>
      </div>
    )
  }

  return (
    <div className='modern-compact-menu'>
      <div className='menu-container'>
        {menus.map((menu, index) => (
          <MenuItem key={index} to={menu.to} title={renderMenu(menu)} />
        ))}

        <div onClick={() => setShowMore(!showMore)}>
          <div className={`compact-menu-item more-button ${showMore ? 'more-button-active' : ''}`}>
            <div className='compact-icon more-icon'>
              <i className={`fas fa-${showMore ? 'times' : 'plus'}`}></i>
            </div>
            <div className='menu-shine'></div>
          </div>
        </div>
      </div>

      {showMore && (
        <div className='dropdown-panel'>
          <div className='dropdown-grid'>
            {moreMenus.map((menu, index) => {
              const cardContent = renderDropdownCard(menu)

              if (menu.action) {
                return (
                  <div key={index} className='dropdown-item-wrapper' onClick={menu.action}>
                    {cardContent}
                  </div>
                )
              }

              return <MenuItem key={index} to={menu.to} title={cardContent} />
            })}
          </div>
        </div>
      )}

      <Modal
        isShown={isShown}
        hide={toggle}
        modalContent={<MyCard />}
        headerText={t('LABEL.MY_CARD')}
      />

      <style>{`
        .modern-compact-menu {
          width: 100%;
          font-family: 'Inter', 'Poppins', system-ui, sans-serif;
        }

        .menu-container {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
        }

        .compact-menu-item {
          position: relative;
          min-height: 58px;
          padding: 14px 22px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
          transition: all 0.25s ease;
          overflow: hidden;
          border: 1px solid #e5e7eb;
          background: #ffffff;
          box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
        }

        .compact-menu-item:hover {
          transform: translateY(-2px);
          background: #f8fbff !important;
          border-color: #cfe2ff !important;
          box-shadow: 0 8px 20px rgba(13, 110, 253, 0.12);
        }

        .active-menu-item {
          background: #f1f7ff !important;
          border-color: #d6e6ff !important;
          box-shadow: 0 8px 22px rgba(13, 110, 253, 0.14);
        }

        .active-menu-item::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 4px;
          background: #0d6efd;
          border-radius: 4px 4px 0 0;
        }

        .compact-icon {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.25s ease;
        }

        .compact-icon i {
          font-size: 20px !important;
        }

        .compact-menu-item:hover .compact-icon {
          transform: scale(1.08);
        }

        .menu-text {
          display: flex;
          align-items: center;
        }

        .menu-title {
          font-size: 14px;
          font-weight: 600;
          letter-spacing: -0.2px;
          white-space: nowrap;
        }

        .menu-shine {
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent);
          transition: left 0.6s ease;
          pointer-events: none;
        }

        .compact-menu-item:hover .menu-shine {
          left: 100%;
        }

        .more-button {
          min-width: 58px;
          justify-content: center;
          background: #406e89 !important;
          border-color: #406e89 !important;
        }

        .more-button:hover,
        .more-button-active {
          background: #045ce0 !important;
          border-color: #0d6efd !important;
        }

        .more-icon i {
          color: #ffffff !important;
          font-size: 18px !important;
          transition: all 0.25s ease;
        }

        .more-button-active .more-icon i {
          transform: rotate(90deg);
        }

        .dropdown-panel {
          margin-top: 20px;
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 18px;
          box-shadow: 0 30px 50px -20px rgba(0, 0, 0, 0.18);
          border: 1px solid rgba(226, 232, 240, 0.8);
          animation: slideUp 0.35s ease;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(16px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .dropdown-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 12px;
        }

        .dropdown-item-wrapper {
          display: block;
          width: 100%;
        }

        .dropdown-card {
          position: relative;
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 14px 18px;
          border-radius: 18px;
          transition: all 0.25s ease;
          cursor: pointer;
          border: 1px solid;
          overflow: hidden;
        }

        .dropdown-card:hover {
          background: #ffffff !important;
          transform: translateX(6px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
        }

        .active-dropdown-card::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 4px;
          background: #0d6efd;
          border-radius: 4px 4px 0 0;
        }

        .dropdown-icon-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.25s ease;
        }

        .dropdown-icon-wrapper i {
          font-size: 20px !important;
        }

        .dropdown-card:hover .dropdown-icon-wrapper {
          transform: scale(1.08);
        }

        .dropdown-info {
          display: flex;
          flex-direction: column;
        }

        .dropdown-title {
          font-size: 14px;
          font-weight: 600;
          white-space: nowrap;
        }

        @media (max-width: 900px) {
          .menu-container {
            gap: 5px;
          }

          .compact-menu-item {
            min-height: 30px;
            padding: 5px 5px;
            gap: 2px;
          }

          .compact-icon i {
            font-size: 18px !important;
          }

          .menu-title {
            font-size: 13px;
          }
        }

        @media (max-width: 680px) {
          .menu-container {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }

          .compact-menu-item {
            justify-content: center;
          }

          .dropdown-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 480px) {
          .compact-menu-item {
            min-height: 48px;
            padding: 9px 12px;
            gap: 8px;
          }

          .compact-icon i {
            font-size: 16px !important;
          }

          .menu-title {
            font-size: 12px;
          }

          .dropdown-card {
            padding: 11px 14px;
          }

          .dropdown-icon-wrapper i {
            font-size: 18px !important;
          }

          .dropdown-title {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  )
}

export default StdMenu
